import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "../../api/endpoint";
import { apiHandler } from "../../api";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";

const orderData = [
  {
    messageId: "gvafgHjkjfnsdjk",
    request_payload: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    request_response: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    callback_payload: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    callback_response: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
  },
  {
    messageId: "gvafgHjkjfnsdjk",
    request_payload: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    request_response: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    callback_payload: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    callback_response: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
  },
  {
    messageId: "gvafgHjkjfnsdjk",
    request_payload: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    request_response: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    callback_payload: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
    callback_response: {
      context: {
        domain: "nic2004:60232",
        country: "IND",
        city: "std:080",
        action: "search",
        core_version: "1.2.0",
        bap_id: "logistics_buyer.com",
        bap_uri: "https://logistics_buyer.com/ondc",
        transaction_id: "5e09dc50-0c35-4f85-bfc1-6ff8d8143b31",
        message_id: "473e7320-3fab-45f2-b4fc-7f7627b10388",
        timestamp: "2024-08-23T05:13:58.584Z",
        ttl: "PT30S",
      },
      message: {
        intent: {
          category: {
            id: "Express Delivery",
          },
          provider: {
            time: {
              days: "1,2,3,4,5,6,7",
              schedule: {
                holidays: ["2023-06-29", "2023-08-15"],
              },
              duration: "PT30M",
              range: {
                start: "1100",
                end: "2100",
              },
            },
          },
          fulfillment: {
            type: "Delivery",
            start: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560041",
                },
              },
            },
            end: {
              location: {
                gps: "12.453544,77.928379",
                address: {
                  area_code: "560001",
                },
              },
            },
          },
          payment: {
            type: "POST-FULFILLMENT",
            "@ondc/org/collection_amount": "300.00",
          },
          "@ondc/org/payload_details": {
            weight: {
              unit: "kilogram",
              value: 1,
            },
            dimensions: {
              length: {
                unit: "centimeter",
                value: 1,
              },
              breadth: {
                unit: "centimeter",
                value: 1,
              },
              height: {
                unit: "centimeter",
                value: 1,
              },
            },
            category: "Grocery",
            value: {
              currency: "INR",
              value: "300.00",
            },
            dangerous_goods: false,
          },
        },
      },
    },
  },
];

const useLogsListing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authData, userData } = useSelector((state) => state.loginSlice);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalCount, setTotalCount] = useState(null);
  const [logs, setLogs] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bppId, setBppId] = useState(null);
  const [messageId, setMessageId] = useState(null);
  const [transactionId, setTransactionId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [jsonBody, setJsonBody] = useState(null);
  const [openJson, setOpenJson] = useState(false);
  const [actionOptions, setActionOptions] = useState([]);
  const [bapOptions, setBapOptions] = useState([]);
  const [domainOptions, setDomainOptions] = useState([]);
  const [domain, setDomain] = useState("");
  const [show, setShow] = useState(false);
  const [clearStartDate, setClearStartDate] = useState(null);
  const [clearEndDate, setClearEndDate] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [limit, setLimit] = useState(null);

  const { client: rootClient, environment: rootEnvironment } = useSelector(
    (state) => state.configurationSlice
  );

  const onHide = () => {
    setShow(false);
  };

  const debouncedPageChange = useCallback(
    debounce((value) => {
      const page = parseInt(value, 10);
        setCurrentPage(page);
    }, 500),
    []
  );

  const handleInputPageChange = (e) => {
    debouncedPageChange(e.target.value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handlePageSize = (limit) => {
    setPageSize(limit.target.value);

    setCurrentPage(currentPage + 1);
  };

  const fetchLogs = async () => {
    try {
      setLoader(true);
      if (rootClient && rootEnvironment) {
        let url = `${
          endpoint.GET_TRANSACTION_LOGS
        }/${rootClient}/${rootEnvironment}?page=${currentPage || 1}&limit=${
          pageSize || 5
        }`;

        if (bppId) {
          url += `&bapId=${bppId.replace(/"/g, "")}`;
        }

        if (transactionId) {
          url += `&transactionId=${transactionId.replace(/"/g, "")}`;
        }

        if (messageId) {
          url += `&messageId=${messageId.replace(/"/g, "")}`;
        }

        if (actionType) {
          url += `&action=${actionType}`;
        }

        if (domain) {
          url += `&domain=${domain}`;
        }

        if (startDate) {
          url += `&startDate=${startDate}`;
        }
        if (endDate) {
          url += `&endDate=${endDate}`;
        }

        const response = await apiHandler({
          url: url,
          method: "GET",
          authToken: authData,
          navigate,
          dispatch,
        });

        if (response?.data?.success) {
          setLogs(response?.data?.data?.logs);
          setTotalCount(response?.data?.data?.total);
          setLimit(response?.data?.data?.limit);

          setActionOptions(response?.data?.data?.filterOptions?.actionOptions);
          setBapOptions(
            response?.data?.data?.filterOptions?.buyerAppOptions?.map((bap) => {
              return { key: bap, value: bap, flag: bap, text: bap };
            }) || []
          );
          setDomainOptions(response?.data?.data?.filterOptions?.domainOptions);
        } else {
          setLogs([]);
          console.error("Failed to fetch Orders:", response?.data?.message);
        }
      }
    } catch (error) {
      console.error("Error fetching Orders:", error);
      setLogs([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    fetchLogs();
  }, [
    pageSize,
    bppId,
    transactionId,
    messageId,
    actionType,
    domain,
    startDate,
    endDate,
    rootClient,
    rootEnvironment,
  ]);

  useEffect(() => {
    fetchLogs();
  }, [currentPage]);

  return {
    bppId,
    setBppId,
    messageId,
    setMessageId,
    transactionId,
    setTransactionId,
    loader,
    logs,
    actionType,
    setActionType,
    totalCount,
    pageSize,
    currentPage,
    setCurrentPage,
    handlePageChange,
    handleInputPageChange,
    handlePageSize,
    jsonBody,
    setJsonBody,
    openJson,
    setOpenJson,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    actionOptions,
    bapOptions,
    domainOptions,
    domain,
    setDomain,
    onHide,
    show,
    setShow,
    clearEndDate,
    clearStartDate,
    setClearEndDate,
    setClearStartDate,
    showConfirm,
    setShowConfirm,
    limit,
  };
};

export default useLogsListing;
